import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  fulfillmentTrackingUpdateWithinFromModel,
  validateFulfillmentTrackingUpdateWithinCondition,
  type FulfillmentTrackingUpdateWithinState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FULFILLMENT_TRACKING_UPDATE_WITHIN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>
  >,
): ConditionType<
  FulfillmentTrackingUpdateWithinState,
  Condition.FulfillmentTrackingUpdateWithin
> => ({
  name: CONDITION_NAMES[Condition.FULFILLMENT_TRACKING_UPDATE_WITHIN],
  description(numDays) {
    return t("Within {{count}} days of last tracking update", {
      count: +numDays,
    });
  },
  Details(
    props: ConditionTypeDetailsProps<FulfillmentTrackingUpdateWithinState>,
  ) {
    return React.createElement(Details, props);
  },
  empty: (30).toFixed(0),
  fromModel(model) {
    return fulfillmentTrackingUpdateWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FULFILLMENT_TRACKING_UPDATE_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state) {
    return validateFulfillmentTrackingUpdateWithinCondition(state).valid;
  },
});
